import React from 'react';
import Select from 'react-select';

export const getSelectStyles = (isInvalid = false) => ({
  control: (base, state) => ({
    ...base,
    minHeight: '38px',
    borderWidth: '1px',
    borderColor: isInvalid
      ? '#dc3545'
      : state.isFocused
        ? '#1D4ED8'
        : '#d1d7e0',
    boxShadow: 'none',
    '&:hover': {
      borderColor: isInvalid ? '#dc3545' : '#1D4ED8',
    },
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#262B40'
      : state.isFocused
        ? '#f5f8fb'
        : 'white',
    color: state.isSelected ? 'white' : '#374151',
    cursor: 'pointer',
  }),
  placeholder: (base) => ({
    ...base,
    color: '#6c757d',
  }),
});

export const buildSelectOptions = (
  items = [],
  { valueKey = 'id', labelKey = 'name', filter } = {}
) => {
  let list = items.slice();
  if (filter) {
    list = list.filter(filter);
  }

  return list
    .sort((a, b) => String(a[labelKey]).localeCompare(String(b[labelKey])))
    .map((item) => ({
      value: String(item[valueKey]),
      label: item[labelKey],
    }));
};

export const buildStringSelectOptions = (items = []) =>
  items
    .slice()
    .sort((a, b) => String(a).localeCompare(String(b)))
    .map((item) => ({ value: String(item), label: item }));

const SearchableSelect = ({
  options = [],
  value,
  onChange,
  onBlur,
  placeholder = 'Select...',
  isInvalid = false,
  isDisabled = false,
  isClearable = false,
  errorMessage,
  menuPortalTarget = document.body,
  inputId,
  name,
}) => {
  const selectedOption =
    options.find((option) => String(option.value) === String(value)) || null;

  return (
    <>
      <Select
        inputId={inputId}
        name={name}
        options={options}
        value={selectedOption}
        onChange={(selected) => onChange(selected ? selected.value : '')}
        onBlur={onBlur}
        placeholder={placeholder}
        isSearchable
        isClearable={isClearable}
        isDisabled={isDisabled}
        menuPortalTarget={menuPortalTarget}
        styles={getSelectStyles(isInvalid)}
        classNamePrefix="searchable-select"
        noOptionsMessage={() => 'No options found'}
      />
      {isInvalid && errorMessage && (
        <div className="invalid-feedback d-block">{errorMessage}</div>
      )}
    </>
  );
};

export const FormikSearchableSelect = ({
  formik,
  name,
  options,
  placeholder = 'Select...',
  isDisabled = false,
  onChange,
  menuPortalTarget,
  inputId,
}) => (
  <SearchableSelect
    inputId={inputId || name}
    name={name}
    options={options}
    value={formik.values[name]}
    onChange={(value) => {
      if (onChange) {
        onChange(value);
      } else {
        formik.setFieldValue(name, value);
      }
    }}
    onBlur={() => formik.setFieldTouched(name, true)}
    placeholder={placeholder}
    isInvalid={formik.touched[name] && !!formik.errors[name]}
    errorMessage={formik.errors[name]}
    isDisabled={isDisabled}
    menuPortalTarget={menuPortalTarget}
  />
);

export default SearchableSelect;
